import { future } from "@mdx-deck/themes";

export default {
  ...future,
};
